import Vue from 'vue'
// import axios from 'axios'
import store from '../store'
import Api from '@/services/Api'

const API_URL = Vue.prototype.$api

/**
 * Get address suggestions from search, latitude and longitude
 * @param {string} latitude
 * @param {string} longitude
 * @returns {Promise<{ data?: any, error?: any }>}
 */
export async function getAddressDataFromLatLong(latitude, longitude) {
	if (!latitude || !longitude)
		return { data: undefined, error: 'Latitude and longitude is required' }

	const urlQueryParams = new URLSearchParams({ latitude, longitude }).toString()

	try {
		const { data } = await Api().get(`${API_URL}/Common/GetAddressFromGoogle?${urlQueryParams}`, {
			headers: {
				ScreenName: store.state.screenName
			}
		})

		return { data, error: undefined }
	} catch (e) {
		return { data: undefined, error: e }
	}
}

/**
 * Get address suggestions from search, latitude and longitude
 * @param {{ search: string, latitude: string, longitude: string }} param
 * @returns {Promise<{ data?: any, error?: any }>}
 */
export async function getAddressSuggestion({ search, latitude, longitude }) {
	const urlQueryParams = new URLSearchParams({ searchText: search, latitude, longitude }).toString()

	try {
		const { data } = await Api().get(`${API_URL}/Common/GetAddressByGoogle?${urlQueryParams}`)

		return { data, error: undefined }
	} catch (e) {
		return { data: undefined, error: e }
	}
}
